import React, { useEffect, useRef } from 'react';
import '../styles/SisterInstitutions.css';

import pic1 from '../assets/pharmacyclg.webp';
import pic2 from '../assets/bedclg.webp';
import pic3 from '../assets/lawclg.webp';
import pic4 from '../assets/sdpgclg.webp';
import pic5 from '../assets/bcaschool.webp';

const SisterInstitutions = () => {
  const cardsRef = useRef([]);
  const sectionRef = useRef(null);

  const institutions = [
    {
      id: 1,
      link: "https://bihanipharmacycollegesgnr.org/",
      image: pic1
    },
    {
      id: 2,
      link: "https://sdbihanibedcollegesgnr.org/",
      image: pic2
    },
    {
      id: 3,
      link: "https://sdbihanilawcollegesgnr.org/",
      image: pic3
    },
    {
      id: 4,
      link: "https://www.sdbihanipgcollegesgnr.org/",
      image: pic4
    },
    {
      id: 5,
      link: "https://bihanichildrensacademy.com/",
      image: pic5
    }
  ];

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('si-card-animate-in');
        }
      });
    }, observerOptions);

    cardsRef.current.forEach(card => {
      if (card) observer.observe(card);
    });

    return () => {
      cardsRef.current.forEach(card => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  const handleCardClick = (link, comingSoon) => {
    if (!comingSoon && link !== '#') {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      {/* Admission Banner */}
      <div className="si-admission-banner" id="si-banner-section">
        <div className="si-banner-overlay"></div>
        <div className="si-banner-content">
          <h2 className="si-banner-title">OUR SISTER'S CONCERN</h2>
     
        </div>
      </div>

      {/* Sister Institutions Section */}
      <section className="si-institutions-section" id="si-institutions-main" ref={sectionRef}>
        <div className="si-container">
          <div className="si-institutions-grid">
            {institutions.map((institution, index) => (
              <div
                key={institution.id}
                ref={el => cardsRef.current[index] = el}
                className="si-institution-card si-card-enabled"
                onClick={() => handleCardClick(institution.link, false)}
              >
                <div className="si-card-image-wrapper">
                  <img 
                    src={institution.image} 
                    alt="Institution"
                    className="si-card-image"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default SisterInstitutions;